"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IceSpikeShieldAbilityHandler = exports.IceSpikeShieldActorAbilityFactory = exports.IceSpikeShieldAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Damage_1 = require("../../core/Damage");
class IceSpikeShieldAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.IceSpikeShield;
        this.__typeName = "IceSpikeShield";
    }
}
exports.IceSpikeShieldAbilityArgs = IceSpikeShieldAbilityArgs;
let IceSpikeShieldActorAbilityFactory = class IceSpikeShieldActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("IceSpikeShield", "AllAllies", 4);
    }
};
IceSpikeShieldActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("IceSpikeShield")
], IceSpikeShieldActorAbilityFactory);
exports.IceSpikeShieldActorAbilityFactory = IceSpikeShieldActorAbilityFactory;
let IceSpikeShieldAbilityHandler = class IceSpikeShieldAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const level = container.getLevel(ability.invokerId);
        const focus = container.getAttributeScore(ability.invokerId, enums_1.AttributeType.Focus);
        const reflectAmount = level * 5 + focus;
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            animatedId: ability.invokerId,
            fallback: "casting",
            onAnimated: sequence => {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(targetId => {
                    container.applyBuff({
                        sequence,
                        creatorId: ability.invokerId,
                        targetId,
                        duration: Duration_1.Duration.Turns(4),
                        effect: new core_2.LinkedEffectsEffectArgs([
                            new core_2.DamageReciprocateEffectArgs(new Damage_1.Damage(enums_1.DamageType.Frost, reflectAmount)),
                            new core_2.ReciprocateAttackEffectArgs(Duration_1.Duration.Turns(4), new core_2.BleedingEffectArgs("Focus", 10), true, 50),
                            new core_2.LinkedVfxEffectArgs("Aura", sequence.pushArgs(new core_1.AuraVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "chest"), "Frost")))
                        ], false),
                        onApplied: sequence => sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "IceSpikeShield"))
                    });
                });
            }
        });
    }
};
IceSpikeShieldAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.IceSpikeShield)
], IceSpikeShieldAbilityHandler);
exports.IceSpikeShieldAbilityHandler = IceSpikeShieldAbilityHandler;
